import { useState } from "react";
import useSWR from "swr";
import { apFetcher } from "../../../SWR/Utilities/axiosPrivateFetcher_SWR";
import { SWR_KEYS } from "../../../SWR/Utilities/swrKeys";
import { LogLevel } from "../../hooks/useLogging/Logging-types";
import { useLogging } from "../../hooks/useLogging/useLogging";
import { recursiveTokenFilter } from "../../utils/tokenReplacement";
/**
 * useCompanyProviderModel - Fetch Company provider model
 * This makes a GET request to /React/GetCompanyProviderModel using SWR
 *
 * @return {*}
 */
export const useCompanyProviderModel = () => {
    const { datadogLog } = useLogging();
    const [tokenMap, setTokenMap] = useState(new Map());
    const { data, error, isLoading } = useSWR(SWR_KEYS.COMPANY_PROVIDER, apFetcher(`/React/GetCompanyProviderModel`), {
        onSuccess: (data) => {
            if (!data.success) {
                datadogLog("Failed to get CompanyProvider model", LogLevel.ERROR, undefined);
                throw new Error("Something unexpected happened while loading the page. Code: CA1");
            }
            const newTokenMap = new Map();
            for (const key in data.tokenMap) {
                newTokenMap.set(key, data.tokenMap[key]);
            }
            setTokenMap(newTokenMap);
            recursiveTokenFilter(data.companyText, false, newTokenMap);
        },
        onError: (error) => {
            datadogLog("Failed to get CompanyProvider model", LogLevel.ERROR, undefined, error);
        },
    });
    return {
        loading: isLoading,
        data,
        error: error === null || error === void 0 ? void 0 : error.message,
        tokenMap: tokenMap,
    };
};
